import React from 'react';
import PropTypes from 'prop-types';

import { Button, Form, Textarea } from 'components/HookForm';
import Message from 'components/Message';

import { messages } from './ReplyToReviewForm.messages';

import './ReplyToReviewForm.scss';

const COMMUNITY_GUIDELINES_LINK = 'https://classpass.com/about/community-standards';

const ReplyToReviewForm = ({ onCancelClick, onSubmit }) => (
  <>
    <p className="reply-to-review-form__small_text">
      <Message
        message={messages.visibilityDisclaimerText}
        values={{
          a: text => (
            <a href={COMMUNITY_GUIDELINES_LINK} rel="noopener noreferrer" target="_blank">
              {text}
            </a>
          ),
        }}
      />
    </p>
    <Form useFormOverrides={{ mode: 'onTouched' }} onSubmit={onSubmit}>
      <Textarea
        name="response"
        placeholder={messages.replyInputPlaceholder}
        required={messages.fieldRequired}
        autoFocus
      />
      <div className="reply-to-review-form__submit-row">
        <div>
          <Message
            as={Button}
            styled="tertiary"
            className="reply-to-review-form__button bt--sm bt--text-sm"
            onClick={onCancelClick}
            message={messages.cancel}
          />
        </div>

        <div>
          <Message
            as={Button}
            styled="primary"
            className="reply-to-review-form__button bt--sm bt--text-sm"
            data-cypress="reply-to-review-submit-button"
            type={Button.TYPES.SUBMIT}
            message={messages.submit}
          />
        </div>
      </div>
    </Form>
  </>
);

ReplyToReviewForm.propTypes = {
  onCancelClick: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default ReplyToReviewForm;
